import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SyncState {
  isConnected: boolean
  lastSync: Date | null
  queueLength: number
  isSyncing: boolean
  folderId: string | null
  setConnected: (connected: boolean) => void
  setLastSync: (date: Date) => void
  setQueueLength: (length: number) => void
  setSyncing: (syncing: boolean) => void
  setFolderId: (id: string | null) => void
}

export const useSyncStore = create<SyncState>()(
  persist(
    (set) => ({
      isConnected: false,
      lastSync: null,
      queueLength: 0,
      isSyncing: false,
      folderId: null,

      setConnected: (connected) => set({ isConnected: connected }),
      setLastSync: (date) => set({ lastSync: date }),
      setQueueLength: (length) => set({ queueLength: length }),
      setSyncing: (syncing) => set({ isSyncing: syncing }),
      setFolderId: (id) => set({ folderId: id }),
    }),
    {
      name: 'praxis-sync',
      partialize: (state) => ({
        folderId: state.folderId,
        lastSync: state.lastSync,
      }),
    }
  )
)
